export default __webpack_public_path__ + "static/media/messages.cd497797.svg";